export default {"src":"/_next/static/media/SplineB_Pg2Dark_1440x520.2db0f88f.svg","height":520,"width":1440,"blurWidth":0,"blurHeight":0};